import { createEffect, sample } from "effector"
import { t } from "i18next"
import { createEffectorForm, createToggle, Validators } from "@callcenter/effector-helpers"

import type { FeedbackFormData, FeedbackSubmitPayload } from "../shared/types"
import { FeedbackReason } from "../shared/types"
import { DEFAULT_FEEDBACK_FORM } from "../shared/constants"
import { feedbackApi } from "../api"

export const [$isFeedbackModalOpen, _, feedbackModalOpened, feedbackModalClosed] = createToggle()

export const submitFormFx = createEffect<FeedbackFormData, void, Error>(async (formData) => {
  const payload: FeedbackSubmitPayload = {
    reasons: Array.from(formData.reasons),
    ...(formData.missingFeaturesText && { missingFeaturesText: formData.missingFeaturesText }),
    ...(formData.otherText && { otherText: formData.otherText })
  }

  await feedbackApi.submitFeedbackFx(payload)
})

export const { $formValue, $formErrors, handleChange, handleSubmit, formSubmitted, resetForm } = createEffectorForm<
  FeedbackFormData,
  void
>({
  defaultValue: DEFAULT_FEEDBACK_FORM,
  validationSchema: {
    reasons: {
      beforeSubmit: (value) => (value.size === 0 ? t("component_commonKeys_feedbackModal_reasonsRequired") : "")
    },
    missingFeaturesText: {
      beforeSubmit: (value, _err, form) =>
        form.reasons.has(FeedbackReason.missingFeatures) ? Validators.required()(value) : ""
    },
    otherText: {
      beforeSubmit: (value, _err, form) => (form.reasons.has(FeedbackReason.other) ? Validators.required()(value) : "")
    }
  },
  submitFormFx
})

sample({
  clock: submitFormFx.finally,
  target: feedbackModalClosed
})

sample({
  clock: feedbackModalClosed,
  target: resetForm
})
